import { useCallback } from 'react';

import { useNavigate } from 'react-router-dom';

export function useGoHome() {
  const navigate = useNavigate();

  const handleGoHome = useCallback(() => {
    navigate('/');
  }, [navigate]);

  return {
    handleGoHome,
  };
}
